// 此文件由脚本自动生成，请勿直接修改。
// This file was generated automatically by a script. Please do not modify it directly.

import { SelectTokens } from './type';

const selectTokens: SelectTokens = {
  selectWidth: 'Size-120',
  selectFontSize: '14/regular',
  selectFontColor: 'Neutral-text-5',
  selectBorderRadius: 'Radius-4',
  selectBorderColor: 'Neutral-border-2',
  selectPaddingX: 'Padding-8',
  selectPaddingY: 'Padding-2',
  selectIconSize: 'Size-7',
  selectIconColor: 'Neutral-text-4',
  selectSmallFontSize: '12/regular',
  selectSmallPaddingX: 'Padding-8',
  selectSmallPaddingY: 'Padding-1',
  selectSmallOptionInnerPaddingX: 'Padding-8',
  selectSmallOptionInnerPaddingY: 'Padding-2',
  selectLargeFontSize: '16/regular',
  selectLargePaddingX: 'Padding-12',
  selectLargePaddingY: 'Padding-3',
  selectLargeOptionInnerPaddingX: 'Padding-12',
  selectLargeOptionInnerPaddingY: 'Padding-8',
  selectLargePlaceholderMarginY: 'Padding-4',
  selectInnerPaddingX: 'Padding-8',
  selectInnerPaddingY: 'Padding-5',
  selectPlaceholderColor: 'Neutral-text-2',
  selectPlaceholderMarginY: 'Padding-2',
  selectBackgroundColor: 'Neutral-fill-1',
  selectClearColor: 'Neutral-text-3',
  selectClearPadding: 'Padding-8',
  selectHoverBorderColor: 'Brand-6',
  selectHoverClearColor: 'Neutral-text-4',
  selectFocusBorderColor: 'Brand-7',
  selectFocusShadow: 'Brand-2',
  selectDisabledIconColor: 'Neutral-text-2',
  selectDisabledFontColor: 'Neutral-text-2',
  selectDisabledPlaceholderColor: 'Neutral-text-2',
  selectDisabledBorderColor: 'Neutral-border-1',
  selectDisabledBackgroundColor: 'Neutral-fill-2',
  selectResultTextBorderRadius: 'Radius-4',
  selectResultTextPaddingX: 'Padding-4',
  selectResultTextSmallPaddingX: 'Padding-4',
  selectResultTextLargePaddingX: 'Padding-10',
  selectResultTextActiveBackgroundColor: 'Brand-1',
  selectErrorBorderColor: 'Danger-6',
  selectErrorFocusShadow: 'Danger-1',
  selectPanelColor: 'Neutral-text-5',
  selectPanelBackgroundColor: 'Neutral-fill-1',
  selectPanelShadow: 'Shadow-2',
  selectPanelRadius: 'Radius-4',
  selectPanelBorder: 'Neutral-border-1',
  selectOptionHeight: 'Size-16',
  selectOptionPaddingX: 'Padding-4',
  selectOptionPaddingY: 'Padding-1',
  selectOptionActiveColor: 'Brand-6',
  selectOptionActiveBackgroundColor: 'Brand-1',
  selectOptionInnerPaddingX: 'Padding-8',
  selectOptionInnerPaddingY: 'Padding-5',
  selectOptionInnerPaddingRight: 'Size-15',
  selectOptionInnerBorderRadius: 'Radius-2',
  selectOptionHoverBackgroundColor: 'Neutral-fill-2',
  selectOptionDisabledColor: 'Neutral-text-2',
  selectOptionDisabledBackgroundColor: 'Neutral-fill-1',
  selectMorePadding: 'Padding-8',
  selectHeaderPadding: 'Padding-8',
  selectHeaderBorderColor: 'Neutral-border-1',
  selectGroupTitleFontColor: 'Neutral-text-3',
  selectGroupTitleFontSize: '12/regular',
  selectGroupTitlePaddingX: 'Padding-12',
  selectGroupTitlePaddingTop: 'Padding-10',
  selectGroupTitlePaddingBottom: 'Padding-2',
  selectGroupTitleSmallX: 'Padding-8',
  selectGroupTitleSmallTop: 'Padding-4',
  selectGroupTitleLargeX: 'Padding-12',
  selectGroupTitleLargeTop: 'Padding-14',
  selectGroupTitleLargeBottom: 'Padding-4',
  selectColumnPadding: 'Padding-8',
  selectColumnOptionMargin: 'Margin-8',
  selectColumnBorderRadius: 'Radius-4',
  selectColumnBackgroundColor: 'Neutral-fill-2',
};

export default selectTokens;
